import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e5b668b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center mr-1" }
const _hoisted_2 = { class: "material-icons text-2xl mr-1 notranslate" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "text-2xl font-bold"
}
const _hoisted_7 = {
  key: 1,
  class: "text-2xl font-bold"
}
const _hoisted_8 = {
  key: 2,
  class: "text-2xl font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hover-hand border-2 rounded px-4 py-2 w-full hover:shadow-lg transition-shadow duration-200 notranslate", {
      'bg-course text-white': _ctx.isSelect && _ctx.partType === 'COURSE' && _ctx.isLightMode(),
      'bg-challenge text-white': _ctx.isSelect && _ctx.partType === 'CHALLENGE' && _ctx.isLightMode(),
      'bg-bookmark text-white': _ctx.isSelect && _ctx.partType === 'BOOKMARK' && _ctx.isLightMode(),
      'hover:border-course': _ctx.partType === 'COURSE' && _ctx.isLightMode(),
      'hover:border-challenge': _ctx.partType === 'CHALLENGE',
      'hover:border-bookmark': _ctx.partType === 'BOOKMARK' && _ctx.isLightMode(),
      'text-gray-900': !_ctx.isSelect && _ctx.isLightMode(),
      'bg-course-dark text-dark-text border-dark-900': _ctx.isSelect && _ctx.partType === 'COURSE' && !_ctx.isLightMode(),
      'bg-challenge text-dark-text border-dark-900': _ctx.isSelect && _ctx.partType === 'CHALLENGE' && !_ctx.isLightMode(),
      'bg-bookmark-dark text-dark-text border-dark-900': _ctx.isSelect && _ctx.partType === 'BOOKMARK' && !_ctx.isLightMode(),
      'hover:border-course-dark': _ctx.partType === 'COURSE' && !_ctx.isLightMode(),
      'hover:border-bookmark-dark': _ctx.partType === 'BOOKMARK' && !_ctx.isLightMode(),
      'text-dark-text border-dark-400': !_ctx.isSelect && !_ctx.isLightMode()
    }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        (_ctx.partType === 'COURSE')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "map"))
          : (_ctx.partType === 'CHALLENGE')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "inbox"))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "bookmark_border"))
      ]),
      (_ctx.partType === 'COURSE')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('message.course')), 1))
        : (_ctx.partType === 'CHALLENGE')
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('message.challenge')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('message.bookmark')), 1))
    ])
  ], 2))
}